module.exports = "/_next/static/images/avatar_Tomas-aac98608aa6771cfab3df2affb87fd43.svg";